import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Data, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoansService } from 'app/modules/projects/details/loans/loans.service';
import { LoanRequest } from '../loans.types';
import { ProjectAddLoanRequestComponent } from '../modals/add-loan-request/add-loan-request.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { LoanPurpose } from 'app/core/models';
import { AccountService } from 'app/core';
import { Account } from 'app/core/models/account.types';
import { NewPermission } from '@core/enums';

@Component({
  selector: 'project-loan-requests',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoanRequestListComponent implements OnInit, OnDestroy {
  loanRequests: LoanRequest[];
  isLoading: boolean;
  pagination: any;
  selectedLoanRequest: LoanRequest;
  data: any;
  loanPurposes: LoanPurpose[];
  account: Account;
  NewPermission = NewPermission;

  @ViewChild('noteList')
  noteList: ElementRef;

  // Private
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {MailboxComponent} mailboxComponent
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _matDialog: MatDialog,
    private _loansService: LoansService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // Set the defaults
    this.isLoading = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this._activatedRoute.data.subscribe((data: Data) => {
      this.data = data;
      this.loanPurposes = data.options.loan_purposes;
    });

    // Notes
    this._loansService.loanRequests$.pipe(takeUntil(this._unsubscribeAll)).subscribe((loanRequests: LoanRequest[]) => {
      this.loanRequests = loanRequests;
      this._changeDetectorRef.markForCheck();
    });

    // Selected mail
    this._loansService.loanRequest$.pipe(takeUntil(this._unsubscribeAll)).subscribe((loanRequest: LoanRequest) => {
      this.selectedLoanRequest = loanRequest;

      this._changeDetectorRef.markForCheck();
    });

    this._accountService.currentAccount.subscribe((accountData) => {
      if (accountData) {
        this.account = accountData;
      }
    });

    this._checkRedirectToFirstPipeline(this._activatedRoute);

    this._router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        //default route if navigate
        this._checkRedirectToFirstPipeline(this._activatedRoute);
      }
    });
  }

  /**
   * Check if we should redirect to first note
   */
  _checkRedirectToFirstPipeline(route): void {
    if (!route.snapshot.firstChild && this.loanRequests.length > 0) {
      this._router.navigate(['./', this.loanRequests[0].id], { relativeTo: route });
    }
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  addLoanRequest() {
    this._matDialog.open(ProjectAddLoanRequestComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { loanPurposes: this.loanPurposes },
    });
  }

  /**
   * Go to contact
   *
   * @param id
   */
  goToLoanRequest(id: number): void {
    // Get the current activated route
    let route = this._activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }

    // Go to contact
    //this._router.navigate(['/notes/', id]);
    this._router.navigate(['../', id], { relativeTo: route });

    // Mark for check
    this._changeDetectorRef.markForCheck();
  }

  /**
   * On mail selected
   *
   * @param mail
   */
  onLoanRequestSelected(loanRquest: LoanRequest): void {
    // Execute the mailSelected observable
    this._loansService.selectedLoanRequestChange.next(loanRquest);
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
